var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1600px",
    height: "1600px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 16000000 16000000",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".fil0 {fill:#4091CF} .fil1 {fill:white}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M7999787 -47c-4418116,0 -7999787,3581931 -7999787,7999882 0,4417963 3581683,8000224 7999787,8000224 4418116,0 8000224,-3582049 8000224,-8000224 0,-4418164 -3582108,-7999882 -8000224,-7999882z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M12119545 11345143c-28902,551103 -477225,992056 -1031634,1008650 -5386,260 -10500,1654 -16051,1654l-492319 260 -6011779 -260c-587894,0 -1066193,-478347 -1066193,-1066359l0 -5808145c0,-588012 478347,-1066359 1066512,-1066359l2025344 0 1000489 908221 3477947 0c587906,0 1066193,478347 1066193,1066512l0 281067 954886 165 -973394 4674593z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M11071860 6152790l-3798427 0 -1000489 -908221 -1705028 0c-130453,0 -236528,106075 -236528,236374l0 5807991c0,130287 106075,236374 236528,236374l179681 0 943371 -4854959 5617113 0 0 -281079c47,-130228 -106028,-236480 -236221,-236480l0 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolder);
export default __webpack_public_path__ + "static/media/icon-folder.8b7f0c3d1446231131c0d77971fa2e3e.svg";
export { ForwardRef as ReactComponent };